export default "__VITE_ASSET__CZM8nibv__"